import { INavData } from '@coreui/angular';
let childRoutes = [];
// add views accrding to role and permissions.
const permissionData = sessionStorage.getItem('permissionData');
if (permissionData && permissionData.toString() != '0') {
  const permissionDataJson = JSON.parse(permissionData);
  const modulesAndPermissions = permissionDataJson.modulesAndPermissions;
  let permissionArr: any[] = [];
  modulesAndPermissions.map((ele: any) => {
    ele.permissions.map((e: any) => {
      if (e.itemName === 'View' && e.checked)
        permissionArr.push(ele.module);
    })
  })

  childRoutes.push({ name: 'Dashboard', url: '/', href: '#', icon: 'icon-speedometer', }, { title: true, name: 'Modules' },)
  if (permissionArr.includes('Manage User')) {
    childRoutes.push({ name: 'User', url: 'user', href: '#/default/user', icon: 'icon-user' });
  }
  if (permissionArr.includes('Manage Driver')) {
    childRoutes.push({ name: 'Driver', url: 'driver', href: '#/default/driver', icon: 'icon-user' });
  }
  //  if (permissionArr.includes('Manage Order')) {
  //   childRoutes.push({ path: 'order', loadChildren: () => import('./order/order.module').then(m => m.OrderModule) });
  // }


if (permissionArr.includes('Manage Order')) {
  childRoutes.push({
    name: 'Order',
    url: 'order',
    href: '#/default/order',
    icon: 'cil-group',
    children: [
      // SDD Bids menu removed per request
      // { name: 'SDD Bids', url: 'delivery/sdd-bids', href: '#/default/delivery/sdd-bids' }
    ]
  });
  childRoutes.push({
    name: 'Order Intake Live',
    url: 'website-order/website-order-list',
    href: '#/default/website-order/website-order-list',
    icon: 'cil-globe-alt',
  });
  childRoutes.push({
    name: 'Order Intake Staging',
    url: 'website-order/website-order-staging-list',
    href: '#/default/website-order/website-order-staging-list',
    icon: 'cil-globe-alt',
  });
  childRoutes.push({
    name: 'AI journey Live',
    url: 'ai-sessions/ai-session-list',
    href: '#/default/ai-sessions/ai-session-list',
    icon: 'cil-speech',
  });
  childRoutes.push({
    name: 'AI journey Staging',
    url: 'ai-sessions/ai-session-staging-list',
    href: '#/default/ai-sessions/ai-session-staging-list',
    icon: 'cil-speech',
  });
}








  if (permissionArr.includes('Manage Delivery')) {
    childRoutes.push({
      name: 'Delivery',
      url: '/delivery',
      icon: 'cil-car-alt',
      children: [
        {
          name: 'Delivery Rules',
          url: 'delivery/delivery-list',
          href: '#/default/delivery/delivery-list'
        },
      //   {
      //     name: 'SDD Bids',
      //     url: 'delivery/sdd-bids',
      //     href: '#/default/delivery/sdd-bids'
      //   },
      //   {
      //   name: 'SDD Bids',
      //   url: 'delivery/sdd-bids',
      //   href: '#/default/order-bid-list?orderId'
      // }

      ]
    });
  }
 if (permissionArr.includes('Coupon') || permissionArr.includes('Manage Delivery')) {
    childRoutes.push({
      name: 'Coupon',
      url: '/Coupon',
      icon: 'cil-cog',
      children: [
        {
          name: 'Coupon',
          url: 'Coupon',
          href: '#/default/Coupon'
        }
      ]
    });
  }
  


  // Fees menu - show if user has Admin Fee Settings or Delivery permission
  if (permissionArr.includes('Manage Admin Fee Settings') || permissionArr.includes('Manage Delivery')) {
    childRoutes.push({
      name: 'Fees',
      url: '/settings',
      icon: 'cil-cog',
      children: [
        {
          name: 'Admin Fee Settings',
          url: 'admin-fee-settings',
          href: '#/default/admin-fee-settings'
        },
        {
          name: 'Referral',
          url: 'referral-toggle',
          href: '#/default/referral-toggle'
        }
      ]
    });
  }
  

 if (permissionArr.includes('Coupon') || permissionArr.includes('Manage Delivery')) {
    childRoutes.push({
      name: 'coupon',
      url: '/coupon',
      icon: 'cil-cog',
      children: [
        {
          name: 'coupon',
          url: 'coupon',
          href: '#/default/coupon'
        }
      ]
    });
  }




  // Referral - separate menu item with submenus
  if (permissionArr.includes('Manage Referral') || permissionArr.includes('Manage Delivery')) {
    childRoutes.push({
      name: 'Referral',
      url: '/referral',
      icon: 'cil-gift',
      children: [
        // {
        //   name: 'Referral Codes',
        //   url: 'referral/codes',
        //   href: '#/default/referral/codes'
        // },
        {
          name: 'Tracking',
          url: 'referral/tracking',
          href: '#/default/referral/tracking'
        },
        {
          name: 'Status',
          url: 'referral-toggle',
          href: '#/default/referral-toggle'
        },
        {
          name: 'Rewards',
          url: 'referral/settings',
          href: '#/default/referral/settings'
        },
        // {
        //   name: 'Referral Rewards',
        //   url: 'referral/rewards',
        //   href: '#/default/referral/rewards'
        // },
        // {
        //   name: 'Fraud Check System',
        //   url: 'referral/fraud-check',
        //   href: '#/default/referral/fraud-check'
        // },
        // {
        //   name: 'Referral Settings',
        //   url: 'referral/settings',
        //   href: '#/default/referral/settings'
        // },
        // {
        //   name: 'Reports & Analytics',
        //   url: 'referral/reports',
        //   href: '#/default/referral/reports'
        // }
      ]
    });
  }
  if (permissionArr.includes('Manage Package')) {
    childRoutes.push({ name: 'Package', url: 'package', href: '#/default/package', icon: 'icon-social-dropbox' });
  }
  if (permissionArr.includes('Manage Package Content')) {
    childRoutes.push({ name: 'Package Content', url: 'package-content', href: '#/default/package-content', icon: 'icon-social-dropbox' });
  }
  if (permissionArr.includes('Manage Vehicle')) {
    childRoutes.push({ name: 'Vehicle', url: 'vehicle', href: '#/default/vehicle', icon: 'cil-car-alt' });
  }
  if (permissionArr.includes('Manage Role')) {
    childRoutes.push({ name: 'Role', url: 'role', href: '#/default/role', icon: 'cil-lan' });
  }
  if (permissionArr.includes('Manage Staff')) {
    childRoutes.push({ name: 'Staff', url: 'staff', href: '#/default/staff', icon: ' cil-group' });
  }
  if (permissionArr.includes('Manage Payout')) {
    childRoutes.push({ name: 'Payout', url: 'payout', href: '#/default/payout', icon: ' cil-group' });
  }
  if (permissionArr.includes('Manage Refund Request')) {
    childRoutes.push({ name: 'Refund Request', url: 'refund', href: '#/default/refund', icon: ' cil-group' });
  }
  if (permissionArr.includes('Manage User Privacy')) {
    childRoutes.push({ name: 'Privacy Policy', url: 'user-privacy', href: '#/default/user-privacy', icon: 'cil-group' });
  }
  if (permissionArr.includes('Manage User Term Condition')) {
    childRoutes.push({ name: 'Term Condition', url: 'user-term-condition', href: '#/default/user-term-condition', icon: 'cil-group' });
  }
  if (permissionArr.includes('Manage Driver Privacy')) {
    childRoutes.push({ name: 'Driver Policy', url: 'driver-privacy', href: '#/default/driver-privacy', icon: 'cil-group' });
  }
  if (permissionArr.includes('Manage Driver Term Condition')) {
    childRoutes.push({ name: 'Term Condition', url: 'driver-term-condition', href: '#/default/driver-term-condition', icon: 'cil-group' });
  }
  if (permissionArr.includes('Manage Partner Agreement')) {
    childRoutes.push({ name: 'Partner Agreement', url: 'partner-agreement', href: '#/default/partner-agreement', icon: 'cil-group' });
  }
  if (permissionArr.includes('Manage Prohibited Restricted')) {
    childRoutes.push({ name: 'Prohibited & Restricted Item Policy', url: 'prohibited-restricted', href: '#/default/prohibited-restricted', icon: 'cil-group' });
  }
} else {
  childRoutes = [
    { name: 'Dashboard', url: '/', href: '#', icon: 'icon-speedometer', },
    { title: true, name: 'Modules' },
    { name: 'User', url: 'user', href: '#/default/user', icon: 'icon-user' },
    { name: 'Driver', url: 'driver', href: '#/default/driver', icon: 'icon-user' },
    {
  name: 'Order',
  url: 'order/order-list',
  href: '#/default/order/order-list',
  icon: 'cil-group',
  // children: [
    // {
    //   name: 'Order List',
    //   url: 'order/order-list',
    //   href: '#/default/order/order-list'
    // },
    // {
    //   name: 'SDD Bids',
    //   url: 'delivery/sdd-bids',
    //   href: '#/default/delivery/sdd-bids'
    // }
  // ]
},
    {
      name: 'Order Intake Live',
      url: 'website-order/website-order-list',
      href: '#/default/website-order/website-order-list',
      icon: 'cil-globe-alt',
    },
    {
      name: 'Order Intake Staging',
      url: 'website-order/website-order-staging-list',
      href: '#/default/website-order/website-order-staging-list',
      icon: 'cil-globe-alt',
    },
    {
      name: 'AI journey Live',
      url: 'ai-sessions/ai-session-list',
      href: '#/default/ai-sessions/ai-session-list',
      icon: 'cil-speech',
    },
    {
      name: 'AI journey Staging',
      url: 'ai-sessions/ai-session-staging-list',
      href: '#/default/ai-sessions/ai-session-staging-list',
      icon: 'cil-speech',
    },






    
    {
      name: 'Delivery',
      url: 'delivery/delivery-list',
      href: '#/default/delivery/delivery-list',
      icon: 'cil-car-alt',
      // children: [
      //   {
      //     name: 'Delivery Rules',
      //     url: 'delivery/delivery-list',
      //     href: '#/default/delivery/delivery-list'
      //   },
        // {
        //   name: 'SDD Bids',
        //   url: 'delivery/sdd-bids',
        //   href: '#/default/delivery/sdd-bids'
        // }
      // ]
    },
    {
      name: 'Fees',
      url: '/settings',
      icon: 'cil-cog',
      children: [
        {
          name: 'Admin Fee Settings',
          url: 'admin-fee-settings',
          href: '#/default/admin-fee-settings'
        },
        {
          name: 'Partner Commission',
          url: 'partner-commission-settings',
          href: '#/default/partner-commission-settings'
        },
      
      ]
    },
    { name: 'Coupons', url: 'coupon', href: '#/default/coupon', icon: 'fas fa-ticket-alt' },
    {
      name: 'Referral',
      url: '/referral',
      icon: 'cil-gift',
      children: [
        // {
        //   name: 'Referral Codes',
        //   url: 'referral/codes',
        //   href: '#/default/referral/codes'
        // },
        {
          name: 'Tracking',
          url: 'referral/tracking',
          href: '#/default/referral/tracking'
        },
          {
          name: 'Status',
          url: 'referral-toggle',
          href: '#/default/referral-toggle'
        },
        {
          name: 'Rewards',
          url: 'referral/settings',
          href: '#/default/referral/settings'
        }
        // {
        //   name: 'Referral Rewards',
        //   url: 'referral/rewards',
        //   href: '#/default/referral/rewards'
        // },
        // {
        //   name: 'Fraud Check System',
        //   url: 'referral/fraud-check',
        //   href: '#/default/referral/fraud-check'
        // },
        // {
        //   name: 'Reports & Analytics',
        //   url: 'referral/reports',
        //   href: '#/default/referral/reports'
        // }
      ]
    },
    { name: 'Package', url: 'package', href: '#/default/package', icon: 'icon-social-dropbox' },
    { name: 'Package Content', url: 'package-content', href: '#/default/package-content', icon: 'icon-social-dropbox' },
    { name: 'Vehicle', url: 'vehicle', href: '#/default/vehicle', icon: 'cil-car-alt' },
    { name: 'Role', url: 'role', href: '#/default/role', icon: 'cil-lan' },
    { name: 'Staff', url: 'staff', href: '#/default/staff', icon: ' cil-group' },
    { name: 'Payout', url: 'payout', href: '#/default/payout', icon: ' cil-group' },
    { name: 'Refund Request', url: 'refund', href: '#/default/refund', icon: ' cil-group' },
    // { name: 'Order', url: 'order', href: '#/default/order', icon: ' cil-group' },
  ]
}


export const navItems: INavData[] = childRoutes;